import { gql } from "@apollo/client";

export const GET_TRIP_PRICING = gql`
  mutation GetTripPricing($tripReservationLead: TripReservationLead!) {
    MT_GET_TRIP_PRICING(tripReservationLead: $tripReservationLead) {
      code
      error {
        message
        timestamp
        correlationId
      }
      data {
        id
        travelPricingPerPerson {
          value
          currency
        }
        travelTotalPriceWithoutCharge {
          value
          currency
        }
        serviceFees {
          value
          currency
        }
        paimentFees {
          value
          currency
        }
        activitiesTotalPrice {
          value
          currency
        }
        optionsTotalPrice {
          value
          currency
        }
        travelTotalPrice {
          value
          currency
        }
      }
    }
  }
`;

export const getTripPricing = async (
  getTripPricingMutation,
  tripReservationLead
) => {
  try {
    // const accessToken = Cookies.get("ZORNI_AUTH_TOKEN");
    // const bearerToken =accessToken ? 'Bearer '.accessToken : null;
    const { loading, error, data } = await getTripPricingMutation({
      variables: {
        tripReservationLead,
      },
      fetchPolicy: 'no-cache', 
      // context: {
      //   headers: {
      //     authorization: accessToken,
      //   },
      // },
    });
    return { loading, error, data };
  } catch (error) {
    console.error("Error calculating trip pricing:", error.message);
    throw error;
  }
};
